class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    const announcementList = this.querySelector(".announcement__list");
    const announcementItems = announcementList.querySelectorAll(".announcement-item");
    if (announcementItems.length > 0) {
      this.setupAutoScroll(announcementItems);
    }
  }

  setupAutoScroll(items) {
    let currentIndex = 0;
    const totalItems = items.length;

    // Show the current announcement item
    const showItem = (index) => {
      items.forEach((item, i) => {
        item.classList.remove("show", "hide");
        if (i === index) {
          item.classList.add("show");
        } else {
          item.classList.add("hide");
        }
      });
    };

    // Initial display
    showItem(currentIndex);

    // Auto-scroll every 3 seconds
    this.autoScrollInterval = setInterval(() => {
      currentIndex = (currentIndex + 1) % totalItems;
      showItem(currentIndex);
    }, 3000);
  }

  disconnectedCallback() {
    clearInterval(this.autoScrollInterval); // Clean up the interval when the element is removed
  }
}

// Conditionally define the custom element if not already defined
if (!customElements.get("announcement-bar")) {
  customElements.define("announcement-bar", AnnouncementBar);
}
